import React, { FC } from 'react'
import { Button, ButtonProps, CircularProgress, Fade, styled } from '@mui/material'

export interface ILoadingButtonProps extends ButtonProps {
  loading?: boolean
}

export const LoadingButton: FC<ILoadingButtonProps> = ({ loading, children, ...props }) => (
  <ButtonCustom {...props} disabled={props.disabled || loading}>
    <Fade in={!loading}>
      <span>{children}</span>
    </Fade>
    <Fade in={loading}>
      <div className='LoadingButton-progress'>
        <CircularProgress size={24} />
      </div>
    </Fade>
  </ButtonCustom>
)

const ButtonCustom = styled(Button)({
  position: 'relative',
  [`.LoadingButton-progress`]: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})
